<template>
  <modal
    width="480px"
    speed="fast"
    noOutClose
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close"
  >
    <p slot="header">提示</p>
    <div slot="content" class="red-text">
      <p v-if="type === 'loadQues'">
        由于网络问题，加载题目超时。<br/>
        请确认网络正常后点击“重新加载”再次尝试。
      </p>
      <p v-else>
        由于网络问题，保存超时。<br/>
        请确认网络正常后点击“取消”尝试再次保存。
      </p>
    </div>
    <div slot="footer" class="footer-text">
      <p class="title">建议：</p>
      <p class="text">
        1、切换为手机4G热点上网；<br/>
        2、切换到其他较快的网络。<br/>
      </p>
      <button class="btn" @click="loadPage" v-if="type === 'loadQues'">重新加载</button>
      <button class="btn" @click="close" v-else>取消</button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  components: {
    Modal
  },
  props: {
    type: String
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    loadPage() {
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
  .red-text {
    color: #F5222D;
    font-size: 18px;
    text-align: center;
  }
  .footer-text {
    font-size: 16px;
    color: #666;
    line-height: 30px;
    text-align: center;
    .title {
      color: #333;
      text-align: left;
      font-weight: 500;
    }
    .text {
      text-align: left;
    }
    .btn {
      margin-top: 30px;
      @include theme-fill-btn(160px, 42px, 16px, 4px);
    }
  }
  /deep/ .dialog {
    .modal-head {
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      border-bottom: none;
    }
    .footer {
      background-color: #F5F9FF;
      padding: 20px 40px 40px 40px;
      margin: 0;
      border-radius: 0 0 4px 4px;
    }
  }
</style>
